import { ACTIVITY_FEED } from './activityFeed';
import { ALL_PROJECTS_VIEW } from './allProjectsView';
import { CALENDAR_PICKER } from './calendarPicker';
import { CANVAS } from './canvas';
import { COMBO_GRID } from './comboGrid';
import { COMBO_SEARCH } from './comboSearch';
import { COMMENTS } from './comments';
import { COMMON } from './common';
import { COMPARE_VERSIONS } from './compareVersions';
import { CONFIRMATION_DIALOG } from './confirmationDialog';
import { CONNECTION_LOST } from './connectionLost';
import { CONNECTION_STATUS } from './connectionStatus';
import { CREATE_PROJECT } from './createProject';
import { CRITICAL_PATH } from './criticalPath';
import { DCMA_COMPLIANCE } from './dcmaCompliance';
import { DESIGN_COMPONENTS } from './designComponents';
import { DESIGN_DEMOS } from './designDemos';
import { DURATION_CONFIG } from './durationConfig';
import { ELEMENT_NOT_FOUND_DIALOG } from './elementNotFoundDialog';
import { ELEMENT_TEXT_TRUNCATER } from './elementTextTruncater';
import { EMBEDDED_RELATIONSHIPS } from './embeddedRelationships';
import { EMPTY_STATE } from './emptyState';
import { ERROR_TOOL_TIP } from './errorToolTip';
import { FILTERS } from './filters';
import { GANTT } from './gantt';
import { HELP_TOOL_TIP } from './helpToolTip';
import { HOME_PAGE } from './homePage';
import { LOADING } from './loading';
import { LOGIN } from './login';
import { LOOKAHEAD } from './lookahead';
import { MANNY } from './manny';
import { MENU } from './menu';
import { MESSAGE_BOX } from './messageBox';
import { NAVIGATION_DIALOG } from './navigationDialog';
import { NEW_USER } from './newUser';
import { NOT_FOUND_PAGE } from './notFoundPage';
import { ORGANIZATION_SETTINGS } from './organizationSettings';
import { OUTPUTS } from './outputs';
import { PDF_WIZARD } from './pdfWizard';
import { PEEK_WBS_DIALOG } from './peekWbsDialog';
import { PERMISSION_TOOLTIP } from './permissionTooltip';
import { PRE_FETCH_ICONS } from './preFetchIcons';
import { PROGRESS_INDICATOR } from './progressIndicator';
import { PROJECT_DASHBOARD } from './projectDashboard';
import { PROJECT_LIMITS } from './projectLimits';
import { PROJECT_SETTINGS } from './projectSettings';
import { PROJECT_TITLE } from './projectTitle';
import { PROJECT_VERSIONS } from './projectVersions';
import { PROMPT_LIBRARY } from './promptLibrary';
import { RELATIONSHIP_INFO } from './relationshipInfo';
import { REPORTS } from './reports';
import { RESOURCE } from './resource';
import { RESOURCE_EDGES } from './resourceEdges';
import { RESOURCES_PICKER } from './resourcesPicker';
import { RIBBON_STRIPS } from './ribbonStrips';
import { ROOT_PAGE } from './rootPage';
import { SCHEDULER } from './scheduler';
import { SEARCH_POPUP } from './searchPopup';
import { SMART_TOOLTIP } from './smartTooltip';
import { SORTS } from './sorts';
import { STATEFUL_APP } from './statefulApp';
import { SWITCH_BUTTON } from './switchButton';
import { TABLE } from './table';
import { THREE_DOTS } from './threeDots';
import { TIMESPAN } from './timespan';
import { TOAST } from './toast';
import { UNIVERSAL_SEARCH } from './universalSearch';
import { UPDATES_LIST } from './updatesList';
import { VARIANCE_CODES } from './varianceCodes';

export const AUTOMATION_IDS = {
  LOGIN,
  ALL_PROJECTS_VIEW,
  FILTERS,
  CANVAS,
  COMMENTS,
  TABLE,
  RESOURCE,
  VARIANCE_CODES,
  UPDATES_LIST,
  TOAST,
  TIMESPAN,
  THREE_DOTS,
  SWITCH_BUTTON,
  STATEFUL_APP,
  COMBO_SEARCH,
  COMBO_GRID,
  SMART_TOOLTIP,
  SEARCH_POPUP,
  SORTS,
  LOOKAHEAD,
  GANTT,
  CREATE_PROJECT,
  CRITICAL_PATH,
  DCMA_COMPLIANCE,
  CALENDAR_PICKER,
  COMPARE_VERSIONS,
  CONFIRMATION_DIALOG,
  CONNECTION_LOST,
  CONNECTION_STATUS,
  COMMON,
  DESIGN_DEMOS,
  DESIGN_COMPONENTS,
  DURATION_CONFIG,
  EMBEDDED_RELATIONSHIPS,
  HOME_PAGE,
  SCHEDULER,
  RESOURCE_EDGES,
  REPORTS,
  RELATIONSHIP_INFO,
  PROJECT_VERSIONS,
  PROJECT_TITLE,
  PROJECT_SETTINGS,
  PROJECT_LIMITS,
  PROGRESS_INDICATOR,
  PERMISSION_TOOLTIP,
  OUTPUTS,
  PDF_WIZARD,
  ORGANIZATION_SETTINGS,
  RIBBON_STRIPS,
  RESOURCES_PICKER,
  PEEK_WBS_DIALOG,
  MENU,
  NEW_USER,
  NAVIGATION_DIALOG,
  MESSAGE_BOX,
  LOADING,
  PRE_FETCH_ICONS,
  PROJECT_DASHBOARD,
  ELEMENT_TEXT_TRUNCATER,
  EMPTY_STATE,
  ERROR_TOOL_TIP,
  HELP_TOOL_TIP,
  ROOT_PAGE,
  ACTIVITY_FEED,
  MANNY,
  ELEMENT_NOT_FOUND_DIALOG,
  NOT_FOUND_PAGE,
  PROMPT_LIBRARY,
  UNIVERSAL_SEARCH
} as const;
